import { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";

import { userType } from "../../../constant/WebToLead";
import {
  googleRegister,
  outlookRegister,
  userRegister,
} from "../../../actionCreator/signUpActionCreater";
import { AuthContext } from "../../../context/AuthContext";
import { getAccountInfo } from "../../../actionCreator/commonActionCreator";
import { countries } from "../../../constant/Countries";
import { utmSource } from "../../../config";

export const useRegister = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { login } = useContext(AuthContext);
  const source =
    searchParams.get(utmSource) || sessionStorage.getItem(utmSource);
  const loading = useSelector(
    (state) => state.CommonReducer.loading["register"],
  );
  const [error, setError] = useState("");
  const paymentType = searchParams.get("type");
  const handleCreateAccount = async (values, user, type, oauth2Token, captchaToken) => {
    const [firstName, ...lastName] = values?.fullName
      ? values?.fullName.trim().split(" ")
      : ["", ""];
    const formattedPayload = oauth2Token
      ? {
          ...values,
          firstName: user?.firstName,
          lastName: user?.lastName,
          email: user?.email,
          password:
            type === "signup-outlook"
              ? "azure_authenticated"
              : "gmail_authenticated",
          userType:
            type === "signup-outlook" ? userType.AZURE : userType.GOOGLE,
          oauth2Token: oauth2Token,
          captchaToken: captchaToken,
          mobileNo: values?.mobileNo
            ? "+" +
              countries?.find((d) => d?.label === values?.prefix)?.code +
              " " +
              values?.mobileNo
            : null,
          sourceType: source,
        }
      : {
          ...values,
          firstName: firstName,
          lastName: lastName.join(" "),
          userType: userType.NATIVE,
          captchaToken: captchaToken,
          mobileNo: values?.mobileNo
            ? "+" +
              countries?.find((d) => d?.label === values?.prefix)?.code +
              " " +
              values?.mobileNo
            : null,
          sourceType: source,
        };
    let res;
    switch (type) {
      case "signup-outlook":
        res = await dispatch(outlookRegister(formattedPayload));
        break;
      case "signup-google":
        res = await dispatch(googleRegister(formattedPayload));
        break;
      default:
        res = await dispatch(userRegister(formattedPayload));
    }

    if (res?.status === 201) {
      navigate(
        paymentType === "subscribe"
          ? `/signup?type=subscribe&key=${res?.data?.activationKey}&email=${formattedPayload?.email}`
          : `/signup?key=${res?.data?.activationKey}&email=${formattedPayload?.email}`,
      );
    } else if (
      res?.status === 200 &&
      res?.data?.token &&
      ["signup-outlook", "signup-google"]?.includes(type)
    ) {
      const user = await dispatch(getAccountInfo(res?.data?.token));
      await login(res?.data?.token, true, user);
      navigate(paymentType === "subscribe" ? "/checkout" : "/dashboard-view");
    } else if (res?.status === 400) {
      setError(res?.title || "Invalid details provided.");
    } else {
      setError("Something went wrong. Please try again.");
    }
  };

  return { handleCreateAccount, loading, error };
};